import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ServiceAppService } from "../../../security/service-app.service";
import { ListaCargas } from '../interfaces/lista-cargas';
import { InfoCarga } from '../interfaces/info-carga';

@Component({
  selector: 'app-alerta-escalonado',
  templateUrl: './alerta-escalonado.component.html',
  styleUrls: ['./alerta-escalonado.component.scss']
})
export class AlertaEscalonadoComponent implements OnInit {

  exibirDetalhes: boolean = false;
  progress: boolean = false;
  errosNomenclatura = [];
  listaUpload: ListaCargas[] = [];
  progressBarPerc: any;
  infoCargaList: InfoCarga[] = [];
  statusMsg: any;
  arquivoStatus: any;
  arquivoInvalido: any[];
  loading: boolean;
  first = 0;
  rows = 10;
  fileOrder = [
    'Tipo_OS_Alerta',
    'Hierarquia_Alerta',
    'Frequencia_Alerta',
    'Cadastro_Email_Alerta',
    'Nivel_Alerta',
    'Destinatario_Alerta'
  ];

  @ViewChild("fileUploader") fileUpload: FileUpload;

  constructor(private messageService: MessageService, private service: ServiceAppService) { }

  ngOnInit() {
    this.progressBarPerc = 0;
    this.listagemUpload();
  }

  async onUpload(event) {
    try {
      this.progress = true;
      this.arquivoInvalido = [];
      const arquivosRepetidos = [];
      const arquivosSucesso = [];

      this.messageService.add({
        key: "carga",
        severity: "info",
        summary: "Importando...",
        detail: "Aguarde o término da importação, pode fechar a tela e voltar mais tarde!",
        life: 2000,
      });

      if (event.files.length == 6) {
        for (let i = 0; i < event.files.length; i++) {
          const file = event.files[i];
          const fileName = file.name;

          const formData = new FormData();
          formData.append("file", file);

          try {
            await this.service.postArquivo("/carga_montadora/upload", formData).toPromise();
            arquivosSucesso.push(fileName);
            event.files.splice(i, 1);
            i--;
          } catch (handler) {
            this.messageService.add({
              key: "carga",
              severity: "warn",
              summary: "Erro",
              detail: handler.error.erro,
              life: 3000,
            });

            event.files.splice(i, 1);
            i--;
          }
        }
      } else {
        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Alerta",
          detail: `Nem todos os itens necessário estão na fila de upload.`,
          life: 3000,
        });
      }

      if (arquivosRepetidos.length > 0) {
        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Alerta",
          detail: `O(s) seguinte(s) arquivo(s) ja existe(m) no banco de dados: ${arquivosRepetidos.join(", ")}`,
          life: 3000,
        });
        this.removerArquivos(
          event.files.filter((file) => arquivosRepetidos.includes(file.name)),
          this.fileUpload
        );
      }

      if (arquivosSucesso.length > 0) {
        this.messageService.add({
          key: "carga",
          severity: "success",
          summary: "Sucesso",
          detail: `${arquivosSucesso.length} arquivo(s) enviado(s) com sucesso`,
          life: 3000,
        });

        this.progressBarPerc = 100;
        setTimeout(() => {
          this.recarregarDados();
          this.progressBarPerc = 0;
        }, 3000);
      }
    } finally {
      this.progress = false;
    }
  }

  removerArquivos(files: File[], uploader: FileUpload) {
    for (const file of files) {
      const index = uploader?.files?.indexOf(file);
      if (index !== -1) {
        uploader?.remove(null, index);
      }
    }
  }

  progressReport(event) {
    this.fileUpload.progress = event;
  }

  onRemoveFile($event) {
    if ($event && $event.files && $event.files.length == 0) {
      this.progressBarPerc = 0;
    }
  }

  onSelectFile(event: FileUpload) {
    const sortedFiles = [...this.fileUpload.files].sort((a, b) => {
      const nameA = a.name;
      const nameB = b.name;
      const indexA = this.fileOrder.findIndex(prefix => nameA.startsWith(prefix));
      const indexB = this.fileOrder.findIndex(prefix => nameB.startsWith(prefix));
      return indexA - indexB || nameA.localeCompare(nameB);
    });

    this.fileUpload.clear();
    sortedFiles.forEach(file => this.fileUpload.files.push(file));
    console.log(this.fileUpload.files);
    this.progressBarPerc = 0;
  }

  removeFile(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);

    uploader.remove(null, index);
  }

  listagemUpload() {
    this.service.getDados("/carga_montadora/listarCargaAlerta").subscribe((res) => {
      this.listaUpload = res.dados.map((item) => {
        const data = new Date(item.data);
        const fimProcessamento = item.fimProcessamento
          ? new Date(item.fimProcessamento)
          : null;
        const inicioProcessamento = item.inicioProcessamento
          ? new Date(item.inicioProcessamento)
          : null;
        const diferenca =
          fimProcessamento && inicioProcessamento
            ? fimProcessamento.getTime() - inicioProcessamento.getTime()
            : 0;
        const horas = Math.floor(diferenca / 3600000);
        const minutos = Math.floor((diferenca % 3600000) / 60000);
        const segundos = Math.floor(((diferenca % 3600000) % 60000) / 1000);
        this.loading = false;

        return {
          ...item,
          data: data.toLocaleDateString(),
          hora: `${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`,
          fimProcessamento: fimProcessamento
            ? fimProcessamento.toLocaleDateString()
            : "00:00:00",
          horaFimProcessamento: fimProcessamento
            ? `${fimProcessamento
              .getHours()
              .toString()
              .padStart(2, "0")}:${fimProcessamento
                .getMinutes()
                .toString()
                .padStart(2, "0")}:${fimProcessamento
                  .getSeconds()
                  .toString()
                  .padStart(2, "0")}`
            : "00:00:00",
          inicioProcessamento: inicioProcessamento
            ? inicioProcessamento.toLocaleDateString()
            : "00:00:00",
          horaInicioProcessamento: inicioProcessamento
            ? `${inicioProcessamento
              .getHours()
              .toString()
              .padStart(2, "0")}:${inicioProcessamento
                .getMinutes()
                .toString()
                .padStart(2, "0")}:${inicioProcessamento
                  .getSeconds()
                  .toString()
                  .padStart(2, "0")}`
            : "00:00:00",
          diferencaHorario: `${horas.toString().padStart(2, "0")}:${minutos
            .toString()
            .padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`,
        };
      });

      this.listaUpload = this.listaUpload.map((upload) => ({
        ...upload,
        statusString:
          upload.status === 0
            ? "Pendente"
            : upload.status === 1
              ? "Sucesso"
              : upload.status === 2
                ? "Processando"
                : upload.status === 3
                  ? "Erro"
                  : upload.status === 4
                    ? "Pendente p/ Validação"
                    : "Reenviar",
      }));
      this.loading = false;
    });
  }

  recarregarDados() {
    this.loading = true;

    setTimeout(() => {
      this.listagemUpload();
    });
  }

  mostrarDetalhes(item: any) {
    this.buscarIdArquivo(item.id);
    this.exibirDetalhes = true;
  }

  buscarIdArquivo(item) {
    this.service
      .getDados("/carga_montadora/listar/detalhe?id_arquivo=" + item)
      .subscribe((res) => {
        this.infoCargaList = res.dealers;
        this.arquivoStatus = res.status;
        this.statusMsg = res.msg;
      });
  }

  fecharDetalhes() {
    this.exibirDetalhes = false;
    this.listagemUpload();
    this.progressBarPerc = 0;
  }
  getBaseFileName(fileName: string): string {
    return fileName.replace(/_\d{8}$/, '');
  }

  validarUpload(event) {
    this.errosNomenclatura = [];
    let dataReferencia = null;
    let datasDiferentes: boolean = true;

    for (const file of event.files) {
      const fileName = file.name;
      const pattern = /^(Cadastro_Email_Alerta|Destinatario_Alerta|Frequencia_Alerta|Hierarquia_Alerta|Nivel_Alerta|Tipo_OS_Alerta)_(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])\d{4}\.csv$/;

      if (!pattern.test(fileName)) {
        this.errosNomenclatura.push(fileName);
        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Alerta",
          detail: `O(s) seguinte(s) arquivo(s) não segue(m) o padrão de nome correto: ${this.errosNomenclatura.join(", ")}`,
          life: 3000,
        });
        this.removerArquivos(
          event.files.filter((file) => this.errosNomenclatura.includes(file.name)),
          this.fileUpload
        );

      } else {
        const match = fileName.match(pattern);
        const dataArquivo = match[2] + match[3] + match[4];

        if (!dataReferencia) {
          dataReferencia = dataArquivo;
        } else if (dataArquivo !== dataReferencia) {
          datasDiferentes = false;
        }
      }
    }

    if (this.errosNomenclatura.length == 0) {
      if (datasDiferentes) {
        this.onUpload(event);
      } else {
        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Erro",
          detail: `A data dos arquivos não correspondem uma com as outras.`,
          life: 3000,
        });
      }
    }
  }

  baixarArquivo(event: Event, name: string): void {
    event.preventDefault();

    this.service.downloadExcelFile(`/carga_montadora/excel?nomeArquivo=${name}`).subscribe((blob) => {
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(window.URL.createObjectURL(blob));
    }, (error) => {
      this.messageService.add({
        key: "carga",
        severity: "warn",
        summary: "Erro",
        detail: `O arquivo foi removido, pois um arquivo mais recente foi encontrado!`,
        life: 3000,
      });
    });
  }

}
